import { render, staticRenderFns } from "./CookiesControl.vue?vue&type=template&id=6ceb3a58&scoped=true"
import script from "./CookiesControl.vue?vue&type=script&lang=ts"
export * from "./CookiesControl.vue?vue&type=script&lang=ts"
import style0 from "./CookiesControl.vue?vue&type=style&index=0&id=6ceb3a58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb3a58",
  null
  
)

export default component.exports